import { render, staticRenderFns } from "./score-detail.vue?vue&type=template&id=3f1ebc1f&scoped=true&"
import script from "./score-detail.vue?vue&type=script&lang=js&"
export * from "./score-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1ebc1f",
  null
  
)

export default component.exports